import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => {
	return {
		root: {
			width: "100vw",
			height: "100vh",
			backgroundColor: theme.palette.colors.paleGrey,
			position: "fixed",
			top: 0,
			left: 0,
			zIndex: 10102,
			visibility: "visible",
			opacity: 1,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"& svg": {
				height: "100px",
				opacity: 1,
			},
		},
		isHide: {
			opacity: 0,
			visibility: "hidden",
			"& svg": {
				opacity: 0,
			},
			"& $animElement": {
				display: "none",
			},
		},
		wrapper: {
			position: "relative",
		},
		animElement: {
			position: "absolute",
			animation: "preloader 1.5s ease",
			animationDelay: ".2s",
			animationIterationCount: "infinite",
			animationDirection: "alternate",
			width: "100%",
			height: "100%",
			backgroundColor: theme.palette.colors.paleGrey,
			top: 0,
			left: 0,
			transformOrigin: "100% 0",
			transform: "translate(-50%, 100%) rotate(0deg)",
		},
	};
};

class LoadingV2 extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.isHide]: !this.props.show,
				})}
			>
				<div className={classes.wrapper}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						width="120"
						height="89"
						viewBox="0 0 120 89"
					>
						<image
							x="1"
							width="119"
							height="89"
							xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAABZCAYAAAAEn7vMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4goMDwEEghQFVQAADRpJREFUeNrtnXmQHFUdxz+zu7PnhOzmAiQQEhIiKBEFUShKMVWA4QiVBEOsGEFERChAqsSrtLTKPyxFxQNFSykPLMWDQ/HAAkTA8oYCJBggIeEQEjYkIRuy2ezlH9/3q+5dZnd6ul/39Mz6rXrVuzM9fbxv/37vd73XhXULBmkQdAEz3bbTtQ7gAKAEFN1+TUAzMAj0ubYXeMW1rcBLtb4ZH2ip9QUkQCcw3bVu4CDgQGCa+64U2hq5RmwLMAzsA/pD237gv8BTQC8iuhc9AHWHeiF3GnAYMAuYDRwOzEHEdrnWiogzFFwbdf83ufttdq0ItCPpDv9tfTKAJHo3sBF4FNgEbAD+DgzVulMqoZBTtVxCBB6OpHEuIrMNdf5+pFZBBDYRSGW1rYWxxDchsovufF1Aj/vc8Djwb+AR4HfAA7XusHLIE7kHAfOAxUg6Z6POHUJSNMxYMuzvOIRWIney47aisT2MLcCfgF8C9yNprzlqTe5sYIFrc5GUjCDJHKZ8R9ea3HBrctccHg76gJuQRN9Wy86txZhbBBYCi4BDkDU7iMa3fsZ2XqGWnRMBBaRVwg/KNOADrm0EbgauB57O+uKakh8iMnqA44GVwDuAQ13H9AJ7kMQ2GhYCH0Nq+zbg9CxPngW5c4CTgGXAsWjM2gW8jAjNu3T6wjnAHcjSvjCLE6ZJ7kzgROAUNKYOADvReApTh9TxOAG4AblW56d5ojTI7QaOA05GY+pepp6URsHrgB8AjwHnpXECn+S2A0cBbwEORqT2oSDC/0mdGEch6/p+YKnPA/uylueigEMXUrsD7thZkGpBh3bkF3e46yjnQo3ftrjfWqx5EPnVIwSRraxwMnA3cCNwNbAt6QGTktsFHIHGVwvEWwzXN0bdcS0hYP7lIHqgdrntyygmvM+1IdeGEWkWemwlSCwc4O7jEGTVz3Hbkjt3P9JE+0kf64BVwBVobI6NJOS+xnVGEbkyJiG+YJLTgWLIbYisnSiwvwPYDLyICO1DWZ0kKBCQewjwBmQ/zEd++cGhffeQnnR3At9DbuNlyJWq/mZiRKjaURB/OkHwPKwCk0SQmpBETXNtFNgOPIvU1FPA82QjQeMxH3g78GakQpeM+36IdIJCQ8DlwLer/WG15PYgiS26k04WzotKroX7LO86iAh9AqXftlAbMivhZNdWA2/M4Hw/By5AQ0QkRCW3gLIzM5A0jTIxcVHJbUKqtsf934vU7AbghQw6yyeWIJ91JTIs08JzwFrgvig7RyG3iIjtJMjMRAnET0SuGUXdSCK3oBjsEyl2SpZYgwg4K8VzfBS4ptJOlcjtRJZwC7I0o6jZicgtIAt3OjJGNqG8aEOUtJTB8cDFKIGQBm4E3jvZDpORW0JEmK8a1TgaT24TMsJ6kDW7EVhPFWNHneMw4JOIaN9+/wPAqciDeBUm8ket7sh8wzgXZZGp6Yjoh4BfAf9i6hAL8AxwCfKjr/d87ONQNciicl+WI7cLSdoQ8f24UXecEnJf7kBP2VQidTw2A5ciy/o3Ho87FxF8wvgvwuQW0BhbRBIbBxZF6kbj6p9RiqsuqwdTwkPA2cC5iHAfaEf9fEr4QyO3gNySZpIR2+FOtAH4I/Xn0mSJm4EjgS97POY9yB0DAoPKAuhWRVhNZMn270YG02MozltrFJCl34GiXpYggCDebEXotcaJwA+ZYOyMgYXApnDmJs74asGMEoombSDbcplmZIXPR3HfnnFtDhr721yzklV7iIdQNGw3ik/3ojDnw8ii357RffwVOBr4Fn5cp2uATyeJhY4iFVxE/urzGXRCKyJxHno656AKylnuWsIPawENMebrWey3GGrtwGsJjL8Ot++Iu5+nkSF4l9umeY9DyF26D/gRydympcCDhXULBguMDThEUctNKLA/jPzWNOt0rVrycKS2ZiMiCgSJC9MgRl54G+Xv8GfNjJ1jZNiPSP49cCvSVGlhMXAtqjuLixviSm4XsoA3kt60ioORVM1D6TebaWATt8YT4wsm8X3IdWtBKr0TOMO1a4HbUZTo1hTu/XHkPiYhN1andKCQ4ZYUbqoJOfuLEaGdqKpjO4EqzbrWuoDU9D4Co6wFWOHaZuCbwPdRjtkHrga+mOD3fcAz1VRMFNAY1Yt/YgtI5S4D3obG0lfQQzRAvmuw5gNfQuPzZ5HXkARXkoxYULnOLU0EVvJkHWh+cC/+jYp5yAA4Dqn7HYjYeiusKwGfQZL8KeJVpVwOfNXDtVwFPGqSO0wQXQp3aIGg3uhF13xhBqqUXIJU/S6k+uqJ0HLoBj6HSF5bxe+uBL7u4fzLcJrVyB1F6s8qHswPLBBMSPY1nrQgFXwsskj3kH/VGweHAj9GceT5Ffa9Cj8S+05kiAFjY8tGcB9y6HciNfwi/gL+PcAxyBK2meyNjjNRIcIVE3z/EeArHs5zGvCH8AflDKpR5N5YDa8PFJD1uwCNRVmOqebHh4MXWc8gbAG+hqZ1Hhj6PFJFRQScCtxZ7qRpo5VgquYAQYWjT5htMB0FVyxaVSTwW0GktiPDzfYzwoeQ/zyQYl8sQyHa01Fg5gsejnkaCq68CmmT245UcCtSwdbZSWDWfREZL9Pc/3uR878TRcx2E6xSsxuRNup+dwAaImah5MJcNEYeg+wBW/mmH9khPuuTu1F6zgfOpYzEGtIk15YOAnVQUmk1Yma47T6UgdqEMjtbSW7N9yBD72iUG13qzmeImw5NAyuoMHM/rWUTrBAuHLeuFNOdLNbbjTq+D+WIH0PmftrFdQehieJr0bjmeziJi5VECHumQa7N47EERNSAfbl9upHa3QY8iea07qpRh84FLkKF4fNqdA0Ay1FcuyJ8k9uGxlmbeReHXMvRdiI1ux5Jataz7iZCMyL4EygOniXOQFmpSPA5G8/KWeOOSyOI3JnIz74TTaFYT36Ixd3fDcjavRwPUy0j4kyqIBb8kxu3CmMUqeBm4B+ovuhx//3jHdch391nHVQ5rEQ+clXIcjWbchglUMNbUejskRpfU7XYi6JMJyAt4xsriJkzriW5IwTVkg8D95KTlddi4p/A61GY0desxOUkWKisVgt7jiIreD+qTfKVlMgDfC0mdiYxVHEYtZLcEook/YXGIvZqNGUmqT98BgmJBb+Sa/ngSighF+c/Hs+dB/iooACp4qqs4ongk1xbAWaiTFMBEbsNFdZlgRJBkqCEjDdbFGUvCoj4yHz5qqA4G4/ziHxLri1yaQtbm+/b7j57Ac16SwMdyC2xpX2PIChOt2yRLZwNInU/ik2vR5rkXiaYDjkJLsJPBcW78DtBzLtBNYIqK4ZQR7Yh0vvd53s8n6+I5tssQsQeiiS0lWCyOO78tuy9hUdtUZW3ho73EioKvx34qdt/MnyQGAuRlEHFJEAc1Hq95biYhspfj0ILsLQRRMbaCRYcK7cNfx/+zpZyMGwHvoumeDxX5houRSWtSZEKsVD7IEa1aEMFdacDb3L/7yAogY0LexfCXoIo2ywUP94MfB6pdsNl+CE2kR9bCfXyAgtQVuZIFHseQqRaECTNkpkW4ONogtYFSMKv83DcVUTM7iS58LyjSLBMfgFZuOG3iGSFmfgjYzVwS9oXnHdyu5DlayWwNj7WMyIl2n0gz2NuCRlLTWgsbARkRizkl9wO5J8Oo/G1EQrWzyFDYiGfarmI1LGtLdkIOAv4bdYnzaPkFvG79ML4onRb+CwrLKcGxEL+JNf8zSTrX9lyDjMJqjtw2zYUAJmB1L7NhbKaZt9YQcruzmTIG7lxYYmJmciy3oFi2M+iElgrSgf5qbNQYv0ktOjXYvfdK/gb31czBd8I5hMmqTOQEbYBVUo+ROVV0+8BvoEiT6tRAfoq/JC7BvhFrTunnskdQer3QCSdf0O1zdXiZRRD3o1ISYrV5IBYyCe5USRnBElcESW2H0x4Tl9JgFVkEHmKiryRa2p2Mmt2BBlK/aikJemUkvfhh9jzyBGxkD9yQYaPxY7DUmxlsLNQfPkuKudbK+H96C0gSfFuVECfK+SR3BFEnr0Gxl433onIfRKp4aSuy4dQrjYpcjPGjkceyQUR/BJKFtj76AsEtU9JcQl+iE0t0e4DeSXXMID/me6X4Scfu5IcEwv5DD+miQ/jh9jMkwBxMJXIvRit2ZgUK4Bf1/pmomCqkHsJ8B0Px1lFzlVxGFOB3Avx81aQTEpjfKLRyb2IhK8pdXgPOXV3JkPereUkWIdixklxHjkMUERBo0ruErSUfFKsoU6JhcYl18fKbOcDP6v1jSRBI6rlVvRe2yRYQ50TC40puYsY++KJatEQxEJjSm6S+bZ1azyVQyNK7pPEW4phJQ1ELDQmuSNUv+xA7OWA8oxGJBe0SHXUfO9a6iikWA0aldznUdlqpZn8q4Gf1Ppi00KjkguqhlyEljV4NvT5NuAm9LaxugspVoNGtJbD2IpeDrEBEd2MZsrfTX2sLZkI/wNjbq/K3m2kgwAAAABJRU5ErkJggg=="
						/>
					</svg>
					<div className={classes.animElement}></div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(LoadingV2);
